// extracted by mini-css-extract-plugin
export default {"link":"styles_link__A15Ur","primary":"styles_primary__1gIyh","tertiary":"styles_tertiary__EFyUu","capitalized":"styles_capitalized__9n5su"};